import { motion } from "framer-motion";
import { Phone, Mail } from "lucide-react";
import { useLanguage } from "@/contexts/LanguageContext";

const Contact = () => {
  const { t } = useLanguage();

  return (
    <section
      id="kapcsolat"
      data-testid="contact-section"
      className="relative py-24 md:py-32 bg-white overflow-hidden"
    >
      {/* Atmospheric backdrop */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[50rem] h-[50rem] rounded-full bg-[#1B2A4A] opacity-[0.04] blur-3xl" />
      </div>

      <div className="relative max-w-4xl mx-auto px-6 md:px-12 text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8, ease: [0.25, 0.1, 0.25, 1] }}
        >
          <span className="inline-block text-xs md:text-sm font-medium uppercase tracking-[0.25em] text-[#3B82F6] mb-6">
            {t.contact.label}
          </span>
          <h2 className="font-serif text-4xl md:text-5xl lg:text-6xl font-bold text-[#1B2A4A] leading-[1.05] tracking-tight">
            {t.contact.headingStart}{" "}
            <span className="italic font-medium">{t.contact.headingItalic}</span>
          </h2>
          <p className="mt-6 text-lg md:text-xl text-[#475569] font-light max-w-2xl mx-auto">
            {t.contact.description}
          </p>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.8, delay: 0.2, ease: [0.25, 0.1, 0.25, 1] }}
          className="mt-16 grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 text-left"
        >{/* Phone */}
          <a
            href="tel:+36203197459"
            data-testid="contact-phone"
            className="group flex items-center gap-5 p-8 md:p-10 rounded-2xl border border-[#1B2A4A]/10 bg-white transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_25px_50px_-18px_rgba(27,42,74,0.2)] hover:border-[#1B2A4A]/20"
          >
            <div className="flex-shrink-0 inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#F8FAFC] transition-all duration-500 group-hover:bg-[#1B2A4A]">
              <Phone
                strokeWidth={1.5}
                className="w-6 h-6 text-[#1B2A4A] transition-colors duration-500 group-hover:text-white"
              />
            </div>
            <div className="min-w-0">
              <p className="text-xs uppercase tracking-[0.2em] text-[#475569] mb-2">
                {t.contact.phoneLabel}
              </p>
              <p className="font-serif text-2xl md:text-[1.7rem] font-semibold text-[#1B2A4A] group-hover:text-[#3B82F6] transition-colors duration-300 truncate">
                +36 20 319 7459
              </p>
            </div>
          </a>

          {/* Email */}
          <a
            href="mailto:nagys9908@gmail.com"
            data-testid="contact-email"
            className="group flex items-center gap-5 p-8 md:p-10 rounded-2xl border border-[#1B2A4A]/10 bg-white transition-all duration-500 hover:-translate-y-1.5 hover:shadow-[0_25px_50px_-18px_rgba(27,42,74,0.2)] hover:border-[#1B2A4A]/20"
          >
            <div className="flex-shrink-0 inline-flex items-center justify-center w-14 h-14 rounded-full bg-[#F8FAFC] transition-all duration-500 group-hover:bg-[#1B2A4A]">
              <Mail
                strokeWidth={1.5}
                className="w-6 h-6 text-[#1B2A4A] transition-colors duration-500 group-hover:text-white"
              />
            </div>
            <div className="min-w-0">
              <p className="text-xs uppercase tracking-[0.2em] text-[#475569] mb-2">
                {t.contact.emailLabel}
              </p>
              <p className="font-serif text-lg md:text-[1.35rem] font-semibold text-[#1B2A4A] group-hover:text-[#3B82F6] transition-colors duration-300 whitespace-nowrap">
                nagys9908@gmail.com
              </p>
            </div>
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default Contact;
